import type { ComponentProps } from 'react';
import ReactApexChart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';
import { useAppContext } from '../../contexts/AppContext';

type DashboardChartProps = ComponentProps<typeof ReactApexChart>;

export default function DashboardChart({ options = {}, ...props }: DashboardChartProps) {
    const { theme } = useAppContext();
    const dark = theme === 'dark';
    const chartOptions: ApexOptions = {
        ...options,
        theme: { ...options.theme, mode: dark ? 'dark' : 'light' },
        chart: {
            ...options.chart,
            background: 'transparent',
            foreColor: dark ? '#aeb7c4' : '#626b78',
            fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif',
            toolbar: { show: false },
        },
        colors: options.colors || ['#007aff', '#34c759', '#ff9f0a', '#af52de'],
        grid: { ...options.grid, borderColor: dark ? '#ffffff12' : '#0000000d', strokeDashArray: 4 },
        tooltip: { ...options.tooltip, theme: dark ? 'dark' : 'light' },
        legend: { ...options.legend, labels: { ...options.legend?.labels, useSeriesColors: false } },
        noData: { text: 'Sem dados neste período', ...options.noData },
    };
    return <ReactApexChart {...props} options={chartOptions} />;
}
